const $ = window.jQuery;
console.log('scrollToTop');

module.exports = {

    init: function () {
    // Scroll to Top button
    var scrollButton = document.getElementById('scroll-to-top');
    var topHeader = document.getElementById('top-header');
    var susieLogo = document.getElementById('susie-logo');

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        // scrollButton.style.display = 'block';
        scrollButton.classList.add('show-btn');
        topHeader.classList.add('nav-bg-color');
        susieLogo.classList.add('shrink-or-hide-logo');
      } else {
        // scrollButton.style.display = 'none';
        scrollButton.classList.remove('show-btn');
        topHeader.classList.remove('nav-bg-color');
        susieLogo.classList.remove('shrink-or-hide-logo');
      }
    }
    },

};